import colors from "@/constants/colors"

export const homeWrapper = {
  mb: 5,
  pt: { xs: 8, md: 9, lg: 10 },
  flexGrow: 1,
  backgroundColor: colors.primary.background,
}
